export default __webpack_public_path__ + "static/media/small-logo.17745c0b.svg";